import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router";
import Login from "./components/Login/Login";
import Callback from "./components/Login/Callback";
import Preferences from "./components/Preferences.jsx/Preferences";
import UserStore from "./hooks/UserStore";

const root = ReactDOM.createRoot(document.getElementById("root"));

// http://localhost:4000/auth/spotifyCallback?code=aut-code&state=state

root.render(
  <React.StrictMode>
    <UserStore>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/callback" element={<Callback />} />
          <Route path="/preferences" element={<Preferences />} />
        </Routes>
      </BrowserRouter>
    </UserStore>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
